export const JSON_CONTENT = 'application/json';
//# sourceMappingURL=contentTypes.js.map